import React from "react";
import styled from "styled-components";
import { getHrefProps } from "@utils/prismic-render-utils";

const DocGroupsWrapper = styled.div`
	h2,
	h3,
	h4,
	h5,
	h6 {
		font-size: 1.3em;
	}
`;

// eslint-disable-next-line  react/display-name
const RenderLinkGroups = React.memo(
	({
		groups,
		colSpan,
		linkGroupClass,
		linkGroupContainerClass,
		defaultExpanded,
	}) => {
		return (
			<DocGroupsWrapper className="w-100">
				<div
					className={`row w-100 m-0 p-0 ${linkGroupContainerClass ||
						""}`}
				>
					{groups.map(({ header, links, id }) => (
						<div
							key={id}
							className={`col-xl-${colSpan} py-3 ${linkGroupClass ||
								""}`}
						>
							<div className="card w-100 h-100 text-light">
								<div className="card-header bg-dark m-0 p-0 text-center">
									<a
										className="text-light"
										data-toggle="collapse"
										href={`#collapse-${id}`}
										role="button"
										aria-expanded={
											defaultExpanded ? "true" : "false"
										}
										aria-controls={`collapse-${id}`}
									>
										{header}
									</a>
								</div>
								<div
									className={`card-body p-0 collapse${
										defaultExpanded ? " show" : ""
									}`}
									id={`collapse-${id}`}
								>
									<ul className="list-group m-0 w-100 bg-light p-0 h-100">
										{links.map(
											({ url, displayText, id }) => (
												<li
													key={id}
													className="list-group-item"
												>
													<a {...getHrefProps(url)}>
														{displayText}
													</a>
												</li>
											)
										)}
									</ul>
								</div>
							</div>
						</div>
					))}
				</div>
			</DocGroupsWrapper>
		);
	},
	(prevProps, nextProps) => {
		return (
			prevProps.groups.length == nextProps.groups.length &&
			prevProps.colSpan == nextProps.colSpan
		);
	}
);
export default RenderLinkGroups;
